import React from 'react';
import PropTypes from 'prop-types';
import CustomPageDetailContentHeader from './CustomPageDetailContentHeader';
import FileSize from '../../FileSize';

export default class CustomPageDetailContentCatalogModalItem extends React.Component {

  static propTypes = {
    pageBlockItem: PropTypes.any.isRequired
  };

  render() {
    let pageBlockItem = this.props.pageBlockItem;

    let itemPreviewImageUrlList = Array.isArray(pageBlockItem.itemPreviewImageUrls)?pageBlockItem.itemPreviewImageUrls.map(function(itemPreviewImageUrl, i){
      return <li key={i}><figure className="img"><span><img className="m_imgShadow" src={itemPreviewImageUrl}/></span></figure></li>
    }):undefined;

    return (
      <div className="modal fade" id={`catalog_modal_${pageBlockItem.pageBlockItemId}`} tabIndex="-1" role="dialog"
           aria-labelledby="myLargeModalLabel" aria-hidden="true">

        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="myLargeModalLabel">カタログプレビュー</h3>
              <button className="close" type="button" data-dismiss="modal"><span aria-hidden="true">×</span><span
                className="sr-only">閉じる</span></button>
            </div>

            <div className="modal-body">
              <div className="m_box2col">
                <div className="m_itemSlides col js_slider">
                  <ul data-document-total-page-number={pageBlockItem.extendProperties.documentTotalPageNumber}>
                    {itemPreviewImageUrlList}

                    {!itemPreviewImageUrlList &&
                      /* If empty display item image */
                      <li>
                        <figure className="img"><span><img className="m_imgShadow" src={pageBlockItem.itemImageUrl}/></span>
                        </figure>
                      </li>
                    }
                  </ul>
                  <div className="slidePaging"><span></span>ページ</div>
                </div>
                <div className="col">
                  <h4 className="ttl">{pageBlockItem.itemName}</h4>
                  <figure className="logo">
                    <img style={{width: '40px'}} src={pageBlockItem.itemCompanyLogoUrl}/>
                    <figcaption className="cap">{pageBlockItem.itemCompanyName}</figcaption>
                  </figure>
                  <div className="label">{pageBlockItem.itemCategoryName}</div>
                  <div className="m_accWrap js_readmore" data-more="カタログ説明文を全部表示 &amp;#xf067;"
                       data-less="カタログ説明文を閉じる &amp;#xf068;">
                    <div className="accInner js_readmoreTarget">
                      {pageBlockItem.itemDescription && <p className="subTxt" style={{whiteSpace: 'pre-wrap'}}>{pageBlockItem.itemDescription}</p>}
                    </div>
                  </div>
                  <p className="m_btn s_dl"><a id="previewCatalogDownloadLink" className="js_modal" data-toggle="modal" data-target="#catalogDownloadModal" data-company_id={pageBlockItem.extendProperties.cluezCompanyId} data-catalog_id={pageBlockItem.extendProperties.cluezCatalogId}><i className="fa fa-download fa-fw"></i> ダウンロード<span
                    className="sub">(<FileSize documentSizeBytes={pageBlockItem.extendProperties.documentSizeBytes}/>)</span></a></p>
                  <p className="m_btn s_gray"><a href={pageBlockItem.itemUrl}>カタログ詳細を見る</a></p>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <div className="m_btn s_gray">
                <button className="txt" type="button" data-dismiss="modal" aria-hidden="true">閉じる</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
